<!-- eslint-disable vue/no-v-html -->
<template>
    <div>
        <span class="read-more" v-html="textToDisplay" />
        <a
            v-if="textExtendsLimit"
            class="link is-blue font-semibold cursor-pointer"
            :class="{ 'block mt-lg' : showFull }"
            @click="toggle"
        >
            {{ toggleLabel }}
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: true,
            },
            lengthLimit: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                showFull: false,
            };
        },
        computed: {
            textToDisplay() {
                let text = this.text;
                if (this.textExtendsLimit && ! this.showFull) {
                    text = `${text.substring(0, this.lengthLimit)}...`;
                }

                return text;
            },
            textExtendsLimit() {
                return this.text.length > this.lengthLimit;
            },
            toggleLabel() {
                if (this.showFull) {
                    return lang('Läs mindre', 'Show less');
                }

                return lang('Läs mer', 'Show more');
            },
        },
        methods: {
            toggle() {
                this.showFull = ! this.showFull;
            },
        },
    };
</script>
